import { Link } from "react-router-dom";
import { overviewDestination } from "../lib/adminNavigation";

const tileClasses = "card block w-full p-4 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2";

export default function AdminOverviewTiles({ overview }) {
  return (
    <div className="mt-8 grid gap-4 sm:grid-cols-3 lg:grid-cols-5" data-testid="admin-overview">
      {Object.entries(overview).map(([key, value]) => {
        const destination = overviewDestination(key);
        const label = key.replace(/_/g, " ");
        const content = (
          <>
            <span className="text-xs uppercase tracking-wider text-slate-500">{label}</span>
            <span className="mt-1 block text-2xl font-semibold">{value}</span>
          </>
        );

        if (destination.route) {
          return (
            <Link key={key} to={destination.route} data-testid={`overview-tile-${key}`}
              className={`${tileClasses} hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md active:translate-y-0 active:bg-blue-50`}>
              {content}
            </Link>
          );
        }

        return (
          <button key={key} type="button" disabled title={destination.unavailable}
            aria-label={`${label}: ${destination.unavailable}`} data-testid={`overview-tile-${key}`}
            className={`${tileClasses} cursor-not-allowed opacity-60`}>
            {content}
            <span className="mt-2 block text-xs text-slate-500">Unavailable — {destination.unavailable}</span>
          </button>
        );
      })}
    </div>
  );
}
